import React from 'react';

const Home = ( props ) => {

    return (
        <g id="path">
            <path d="m3 14.2 9.16-9.65 8.84 10"/>
            <path d="m18 11.5v7h-12v-7"/>
        </g>
    )
};

export default Home;